// eslint-disable-next-line import/prefer-default-export
export const GET_LOGS_URL = `https://api.tizeti.com/api/v1/users/logs`;
